import { string, object, ObjectSchema, TypedForm, array } from 'libs/form';

import { localFileScheme } from '../helpers/localFile';
import { LocalFileEntity } from '../types';

import { AddressFormType } from './registrationAddressForm';

export interface CompanyRegistrationAddressFormType {
  companyRegistrationAddress: AddressFormType & {
    confirmationFiles?: LocalFileEntity[];
  };
}

export const companyRegistrationAddressObject = object({
  country: object({
    id: string().required(),
    name: string().required(),
  })
    .required()
    .default(null),
  locality: string().required().max(200),
  region: string().required().max(200),
  area: string().max(200),
  street: string().required().max(200),
  house: string().required().max(200),
  building: string().max(200),
  apartment: string().max(200),
  postalCode: string().required().max(200),
});

export const getCompanyRegistrationAddressSchema = (
  enabledDocuments?: boolean
): ObjectSchema<CompanyRegistrationAddressFormType> =>
  object({
    companyRegistrationAddress: companyRegistrationAddressObject.concat(
      enabledDocuments
        ? object({
            confirmationFiles: array()
              .of(localFileScheme.required())
              .required()
              .min(1),
          })
        : object({})
    ),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<CompanyRegistrationAddressFormType>();
